// source: proto/messages/paging.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.proto.messages.FirstPagingQuery', null, global);
goog.exportSymbol('proto.proto.messages.PagingQuery', null, global);
goog.exportSymbol('proto.proto.messages.PagingQuery.KindCase', null, global);
goog.exportSymbol('proto.proto.messages.SortKey', null, global);
goog.exportSymbol('proto.proto.messages.SortOrder', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.messages.FirstPagingQuery = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.proto.messages.FirstPagingQuery, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.messages.FirstPagingQuery.displayName = 'proto.proto.messages.FirstPagingQuery';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.proto.messages.PagingQuery = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.proto.messages.PagingQuery.oneofGroups_);
};
goog.inherits(proto.proto.messages.PagingQuery, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.proto.messages.PagingQuery.displayName = 'proto.proto.messages.PagingQuery';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.messages.FirstPagingQuery.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.messages.FirstPagingQuery.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.messages.FirstPagingQuery} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.messages.FirstPagingQuery.toObject = function(includeInstance, msg) {
  var f, obj = {
    limit: jspb.Message.getFieldWithDefault(msg, 1, 0),
    order: jspb.Message.getFieldWithDefault(msg, 2, 0),
    key: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.messages.FirstPagingQuery}
 */
proto.proto.messages.FirstPagingQuery.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.messages.FirstPagingQuery;
  return proto.proto.messages.FirstPagingQuery.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.messages.FirstPagingQuery} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.messages.FirstPagingQuery}
 */
proto.proto.messages.FirstPagingQuery.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setLimit(value);
      break;
    case 2:
      var value = /** @type {!proto.proto.messages.SortOrder} */ (reader.readEnum());
      msg.setOrder(value);
      break;
    case 3:
      var value = /** @type {!proto.proto.messages.SortKey} */ (reader.readEnum());
      msg.setKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.messages.FirstPagingQuery.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.messages.FirstPagingQuery.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.messages.FirstPagingQuery} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.messages.FirstPagingQuery.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLimit();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getOrder();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getKey();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * optional uint32 Limit = 1;
 * @return {number}
 */
proto.proto.messages.FirstPagingQuery.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.proto.messages.FirstPagingQuery} returns this
 */
proto.proto.messages.FirstPagingQuery.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional SortOrder order = 2;
 * @return {!proto.proto.messages.SortOrder}
 */
proto.proto.messages.FirstPagingQuery.prototype.getOrder = function() {
  return /** @type {!proto.proto.messages.SortOrder} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.proto.messages.SortOrder} value
 * @return {!proto.proto.messages.FirstPagingQuery} returns this
 */
proto.proto.messages.FirstPagingQuery.prototype.setOrder = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional SortKey key = 3;
 * @return {!proto.proto.messages.SortKey}
 */
proto.proto.messages.FirstPagingQuery.prototype.getKey = function() {
  return /** @type {!proto.proto.messages.SortKey} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.proto.messages.SortKey} value
 * @return {!proto.proto.messages.FirstPagingQuery} returns this
 */
proto.proto.messages.FirstPagingQuery.prototype.setKey = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.proto.messages.PagingQuery.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.proto.messages.PagingQuery.KindCase = {
  KIND_NOT_SET: 0,
  FIRSTQUERY: 1,
  NEXTQUERY: 2
};

/**
 * @return {proto.proto.messages.PagingQuery.KindCase}
 */
proto.proto.messages.PagingQuery.prototype.getKindCase = function() {
  return /** @type {proto.proto.messages.PagingQuery.KindCase} */(jspb.Message.computeOneofCase(this, proto.proto.messages.PagingQuery.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.proto.messages.PagingQuery.prototype.toObject = function(opt_includeInstance) {
  return proto.proto.messages.PagingQuery.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.proto.messages.PagingQuery} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.messages.PagingQuery.toObject = function(includeInstance, msg) {
  var f, obj = {
    firstquery: (f = msg.getFirstquery()) && proto.proto.messages.FirstPagingQuery.toObject(includeInstance, f),
    nextquery: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.proto.messages.PagingQuery}
 */
proto.proto.messages.PagingQuery.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.proto.messages.PagingQuery;
  return proto.proto.messages.PagingQuery.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.proto.messages.PagingQuery} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.proto.messages.PagingQuery}
 */
proto.proto.messages.PagingQuery.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.proto.messages.FirstPagingQuery;
      reader.readMessage(value,proto.proto.messages.FirstPagingQuery.deserializeBinaryFromReader);
      msg.setFirstquery(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNextquery(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.proto.messages.PagingQuery.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.proto.messages.PagingQuery.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.proto.messages.PagingQuery} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.proto.messages.PagingQuery.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFirstquery();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.proto.messages.FirstPagingQuery.serializeBinaryToWriter
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional FirstPagingQuery firstQuery = 1;
 * @return {?proto.proto.messages.FirstPagingQuery}
 */
proto.proto.messages.PagingQuery.prototype.getFirstquery = function() {
  return /** @type{?proto.proto.messages.FirstPagingQuery} */ (
    jspb.Message.getWrapperField(this, proto.proto.messages.FirstPagingQuery, 1));
};


/**
 * @param {?proto.proto.messages.FirstPagingQuery|undefined} value
 * @return {!proto.proto.messages.PagingQuery} returns this
*/
proto.proto.messages.PagingQuery.prototype.setFirstquery = function(value) {
  return jspb.Message.setOneofWrapperField(this, 1, proto.proto.messages.PagingQuery.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.proto.messages.PagingQuery} returns this
 */
proto.proto.messages.PagingQuery.prototype.clearFirstquery = function() {
  return this.setFirstquery(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.messages.PagingQuery.prototype.hasFirstquery = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string nextQuery = 2;
 * @return {string}
 */
proto.proto.messages.PagingQuery.prototype.getNextquery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.proto.messages.PagingQuery} returns this
 */
proto.proto.messages.PagingQuery.prototype.setNextquery = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.proto.messages.PagingQuery.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.proto.messages.PagingQuery} returns this
 */
proto.proto.messages.PagingQuery.prototype.clearNextquery = function() {
  return jspb.Message.setOneofField(this, 2, proto.proto.messages.PagingQuery.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.proto.messages.PagingQuery.prototype.hasNextquery = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * @enum {number}
 */
proto.proto.messages.SortOrder = {
  ASC: 0,
  DESC: 1
};

/**
 * @enum {number}
 */
proto.proto.messages.SortKey = {
  CREATE_AT: 0,
  PROJECTS_ALL: 1
};

goog.object.extend(exports, proto.proto.messages);
